import { LDRecord } from '@launchdarkly/session-replay';

/**
 * Stable link to the current LaunchDarkly session replay.
 *
 * Safe to set once and reuse: it points at the session as a whole rather than a
 * moment in it, so it can't go stale over the life of the session.
 *
 * Returns undefined until session replay has started, so an absent value means
 * "no session yet" rather than an error.
 */
export function getSessionUrl(): string | undefined {
  return LDRecord.getSession()?.url;
}

/**
 * Session replay URL for the current LaunchDarkly session, with a timestamp so
 * the link opens at the moment of the event.
 *
 * Must be resolved per event — caching it would point every consumer at the
 * time of the first call.
 *
 * Returns undefined until session replay has started, so an absent value means
 * "no session yet" rather than an error. Errors thrown very early in page load
 * can legitimately have no session URL.
 */
export function getSessionUrlWithTimestamp(): string | undefined {
  return LDRecord.getSession()?.urlWithTimestamp;
}
